export default __webpack_public_path__ + "static/media/001.7a66f338.png";